import { clampToPerformanceRetentionFloor } from '@constants/defaultTime';
import { dayjs } from '../../../utils/dayjs';
import { ALL_FILTER_VALUE, DETAILIZATION_TAB_KEYS, FILTER_PARAMS, FILTERS_STORAGE_KEY } from '../constants';

const DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const FILTER_DEFAULTS = {
    [FILTER_PARAMS.DATE_FROM]: () => dayjs().utc().subtract(1, 'month').startOf('day').format(DATETIME_FORMAT),
    [FILTER_PARAMS.DATE_TO]: () => dayjs().utc().endOf('day').format(DATETIME_FORMAT),
    [FILTER_PARAMS.CAMPAIGN_ID]: ALL_FILTER_VALUE,
    [FILTER_PARAMS.DEVICE_TYPE]: ALL_FILTER_VALUE,
    [FILTER_PARAMS.CUSTOMER_TYPE]: ALL_FILTER_VALUE,
    [FILTER_PARAMS.DETAILIZATION_TAB]: DETAILIZATION_TAB_KEYS.DAYS
};

export function readFiltersFromStorage() {
    try {
        const raw = localStorage.getItem(FILTERS_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.error('Failed to read performance filters from localStorage', error); // eslint-disable-line
        return null;
    }
}

export function saveFiltersToStorage(params) {
    try {
        localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(params));
    } catch (error) {
        console.warn('Failed to save performance filters to localStorage', error); // eslint-disable-line
    }
}

const toStoredDate = (value) => {
    if (!value) return null;
    const date = dayjs(value);
    return date.isValid() ? date : null;
};

// Date range shared by the Performance and Home tabs, or null when none usable has been saved
export function readDateRangeFromStorage() {
    const savedFilters = readFiltersFromStorage();
    const dateFrom = toStoredDate(savedFilters?.[FILTER_PARAMS.DATE_FROM]);
    const dateTo = toStoredDate(savedFilters?.[FILTER_PARAMS.DATE_TO]);

    if (!dateFrom || !dateTo || dateTo.isBefore(dateFrom)) return null;

    return {
        [FILTER_PARAMS.DATE_FROM]: clampToPerformanceRetentionFloor(dateFrom.format(DATETIME_FORMAT)),
        [FILTER_PARAMS.DATE_TO]: clampToPerformanceRetentionFloor(dateTo.format(DATETIME_FORMAT), { endOfDay: true })
    };
}

export function saveDateRangeToStorage(dateRange) {
    saveFiltersToStorage({ ...readFiltersFromStorage(), ...dateRange });
}

export function getFilters(searchParams, savedFilters, defaults = {}) {
    return Object.values(FILTER_PARAMS).reduce((acc, key) => {
        const defaultVal = typeof defaults[key] === 'function' ? defaults[key]() : defaults[key];
        acc[key] = searchParams.get(key) ?? savedFilters?.[key] ?? defaultVal;
        return acc;
    }, {});
}
